<div class="main-modal-container">
  <div class="close-modal-container">
    <img
      (click)="closeModal()"
      src="/assets/icons/ close-modal-icon.png"
      alt=""
    />
  </div>
  <div class="modal-content">
    <!-- 
      **
      * Delete Client
      *
     -->
    <ng-container *ngIf="modalType == 'deleteClient'">
      <img src="/assets/icons/clients-icon.png" alt="" />
      <h1 class="label-title">Delete Client {{ client.companyName }}</h1>
      <h3>
        This action will delete {{ client.companyName }} and all associated
        approver members
      </h3>
      <button
        [busy]="removeClientLoading$ | async"
        class="modal-button"
        gbui-button
        type="submit"
        (click)="dispatchRemoveClient()"
      >
        Delete
      </button>
    </ng-container>
    <!-- 
      **
      * Delete Client Success
      *
     -->
    <ng-container *ngIf="modalType == 'deleteClientSuccess'">
      <img
        class="modal-success-icon"
        src="/assets/icons/success-modal-icon.png"
        alt=""
      />
      <h1 class="label-title">Deleted Successfully</h1>
      <h3 class="h3-success">The client has been deleted successfully.</h3>
      <button
        (click)="navigateToClientList()"
        class="modal-button"
        gbui-button
        type="submit"
      >
        Go Back
      </button>
    </ng-container>

    <!-- 
      **
      * Remove Member
      *
     -->
    <ng-container *ngIf="modalType == 'removeMember'">
      <h1 class="label-title">Remove member from client</h1>
      <p *ngIf="pendingRequests" for="" class="pending-request">
        This User has {{ pendingRequests }} requests pending to approve
      </p>
      <div class="container">
        <img src="/assets/icons/client-icon.png" alt="" />
        <label for="">{{ member.firstName }} {{ member.lastName }}</label>
      </div>

      <button
        *ngIf="!pendingRequests"
        class="modal-button"
        gbui-button
        type="submit"
        (click)="removeMember()"
        [busy]="removeMemberLoading$ | async"
      >
        Remove
      </button>

      <div class="container" *ngIf="pendingRequests">
        <div class="input-container" [formGroup]="newApproverForm">
          <label for="">Please select a new approver </label>
          <ng-template [ngIf]="approvers$ | async" let-approvers>
            <gbui-input
              formControlName="newApprover"
              select
              placeholder="Select"
            >
              <gbui-option *ngFor="let item of approvers" value="{{ item.id }}">
                {{ item.firstName }}
                {{ item.lastName }}
              </gbui-option>
            </gbui-input>
          </ng-template>
          <ng-template [ngIf]="approversLoading$ | async">
            <div class="loader-container">
              <loader></loader>
              <!-- <mat-spinner
                class="mat-spinner-color"
                [diameter]="50"
              ></mat-spinner> -->
            </div>
          </ng-template>
        </div>
      </div>

      <div class="buttons-container" *ngIf="pendingRequests">
        <button
          class="buttons-outline"
          gbui-button
          type="submit"
          (click)="removeMember()"
        >
          Cancel
        </button>
        <button
          class="buttons align-right"
          gbui-button
          type="submit"
          [busy]="
            (removeAndAssignLoading$ | async) || (removeMemberLoading$ | async)
          "
          [disabled]="newApproverForm.invalid"
          (click)="removeAndAssign()"
        >
          Assign and delete
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="modalType == 'removeMemberSuccess'">
      <img
        class="modal-success-icon"
        src="/assets/icons/success-modal-icon.png"
        alt=""
      />
      <h1 class="label-title">Removed Successfully</h1>
      <h3 class="h3-success">The member has been removed successfully.</h3>
      <button
        class="modal-button"
        gbui-button
        type="submit"
        (click)="closeModal()"
      >
        Go Back
      </button>
    </ng-container>
  </div>
</div>
